import api from '@/helpers/api'
import Page from "../pages/model";
import {assign} from 'lodash'


export default {
    state: {

    },

    mutations: {

    },

    getters: {
        ticketsIndex (state, getters) {
            return getters.query().with('questions').get()
        },
        ticketById (state, getters) {
            return (ticketId) => {
                return getters.query().with('questions').find(ticketId)
            }
        }
    },

    actions: {
        fetchById(store, ticketId) {
            Page.dispatch('addLoader', 'tickets.fetchById')

            return api.get(`/api/v1/tickets/${ticketId}`)
                .then(res => {
                    store.dispatch('insertOrUpdate', { data: res.data.data })
                    return res
                }).finally(()=>{
                    Page.dispatch('removeLoader', 'tickets.fetchById')
                })
        },
        fetchItems (store, params) {
            Page.dispatch('addLoader', 'tickets.fetchItems')

            return api.get('/api/v1/tickets', {params: assign({}, {PerPage: 12, SortBy: 'title', SortDirection: 'ASC', }, params)})
                .then(res => {
                    store.dispatch('insertOrUpdate', { data: res.data.data })
                    return res
                }).finally(()=>{
                    Page.dispatch('removeLoader', 'tickets.fetchItems')
                })
        },
    }
}
